import api, { formatApiError } from "@/lib/api";

function loadScript() {
  if (window.Razorpay) return Promise.resolve(true);
  return new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

// Opens Razorpay Standard Checkout. Amount + order come from the backend.
export async function startCheckout({ onSuccess, onFailure, onDismiss }) {
  const ok = await loadScript();
  if (!ok) {
    onFailure?.("Could not load the payment window. Check your internet and try again.");
    return;
  }
  let data;
  try {
    ({ data } = await api.post("/payments/order"));
  } catch (e) {
    onFailure?.(formatApiError(e.response?.data?.detail));
    return;
  }
  const options = {
    key: data.key_id,
    amount: data.amount,
    currency: data.currency,
    order_id: data.order_id,
    name: data.app_name,
    description: "Annual Plan — 365 days",
    image: `${window.location.origin}/icon-192.png`,
    theme: { color: "#0B6B3A" },
    prefill: { name: data.prefill?.name || "", contact: data.prefill?.contact || "" },
    handler: async (resp) => {
      try {
        const { data: v } = await api.post("/payments/verify", {
          razorpay_order_id: resp.razorpay_order_id,
          razorpay_payment_id: resp.razorpay_payment_id,
          razorpay_signature: resp.razorpay_signature,
        });
        onSuccess?.(v);
      } catch (e) {
        onFailure?.(formatApiError(e.response?.data?.detail));
      }
    },
    modal: { ondismiss: () => onDismiss?.() },
  };
  try {
    const rz = new window.Razorpay(options);
    rz.on("payment.failed", (r) => onFailure?.(r?.error?.description || "Payment failed. Please try again."));
    rz.open();
  } catch (e) {
    onFailure?.("Could not open the payment window. Please try again.");
  }
}
